const categories = [
	"Books",
	"Business",
	// "Developer Tools",	// macOS only
	"Education",
	"Entertainment",
	"Finance",
	"Food & Drink",
	// "Games",
	// "Graphics & Design",	// macOS only
	"Health & Fitness",
	"Lifestyle",
	// "Kids", 				// iOS only
	"Magazines & Newspapers",
	"Medical",
	"Music",
	"Navigation",
	"News",
	"Photo & Video", // iOS only
	// "Photography", 		// macOS only
	"Productivity",
	"Reference",
	"Shopping",
	"Social Networking",
	"Sports",
	// "Stickers",
	"Travel",
	"Utilities",
	// "Video",				// macOS only
	"Weather",
];

export const appleCategories = categories.map(c => {
	return {
		key: c,
		label: c,
		value: c,
	};
});
export const appleSubCategories = [...appleCategories];
